var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8889 20.0935H3.33333C1.49239 20.0935 0 18.7504 0 17.0935V3.09351C0 1.43666 1.49239 0.0935059 3.33333 0.0935059H18.8889C19.5026 0.0935059 20 0.541226 20 1.09351V19.0935C20 19.6458 19.5026 20.0935 18.8889 20.0935ZM17.7778 18.0935V16.0935H3.33333C2.71969 16.0935 2.22222 16.5412 2.22222 17.0935C2.22222 17.6458 2.71969 18.0935 3.33333 18.0935H17.7778ZM2.22222 14.2642C2.56976 14.1537 2.94373 14.0935 3.33333 14.0935H17.7778V2.09351H3.33333C2.71969 2.09351 2.22222 2.54123 2.22222 3.09351V14.2642ZM10 8.09351C8.77267 8.09351 7.77778 7.19808 7.77778 6.09351C7.77778 4.98894 8.77267 4.09351 10 4.09351C11.2273 4.09351 12.2222 4.98894 12.2222 6.09351C12.2222 7.19808 11.2273 8.09351 10 8.09351ZM6.66667 12.0935C6.66667 10.4366 8.159 9.09351 10 9.09351C11.841 9.09351 13.3333 10.4366 13.3333 12.0935H6.66667Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.241be6272bbe6897a83f0b6c1b7ec1a6.svg";
export { ForwardRef as ReactComponent };